import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAiAnalysis = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: .74,
			d: "M205.749 413.574v6.352c0 .765-.458 1.386-1.021 1.386h-1.794c-.564 0-1.021-.621-1.021-1.386v-6.352c0-.764.457-1.385 1.021-1.385h1.794c.563 0 1.021.621 1.021 1.385",
			transform: "matrix(0 110.085 -81.1265 0 34321.5 -21897.9)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: .69,
			d: "M203.831 421.312c-1.059 0-1.918-.961-1.918-2.145v-4.834c0-1.183.859-2.144 1.918-2.144z",
			transform: "matrix(0 110.085 -98.4586 0 41544.6 -21474.7)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M385.323 488.532c0 28.857-23.41 52.282-52.27 52.282s-52.27-23.425-52.27-52.282c0-28.846 23.41-52.271 52.27-52.271s52.27 23.425 52.27 52.27M743.243 488.532c0 28.857-23.41 52.282-52.27 52.282s-52.27-23.425-52.27-52.282c0-28.846 23.41-52.271 52.27-52.271s52.27 23.425 52.27 52.27" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.992674,
			d: "M312.245 329.64V228.457M720.165 329.64V228.457"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 289.84,
			cy: 165.979,
			r: 85.859,
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 70.84,
			transform: "translate(17.672 -39.255)scale(1.01633)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 289.84,
			cy: 165.979,
			r: 85.859,
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 70.84,
			transform: "translate(425.595 -39.255)scale(1.01633)"
		})
	]
});
export default SvgIconAiAnalysis;
